import { create } from "zustand";
import { filter, Key } from "interface";
import { articleForm, articleManagementFilter, articlesInfo } from "../../type";
type ArticleManagementStore = {
  formData?: Partial<articleForm>;
  headerInfo: articlesInfo;
  setHeaderInfo?: (info?: articlesInfo) => void;
  selectedArticlesId?: Key[];
  filter?: filter<articleManagementFilter>[];
  setFormData: (formData?: articleForm) => void;
  setFilter: (filter: filter<articleManagementFilter>[]) => void;
  setSelectedArticlesId: (value: Key[]) => void;
  page: number;
  setPage: (value: number) => void;
};

export const useArticleManagementStore = create<ArticleManagementStore>(
  (set) => {
    return {
      setFormData: (value: Partial<articleForm> | undefined) => {
        set({ formData: value });
      },
      headerInfo: {
        totals: 0,
      },
      setHeaderInfo: (info: articlesInfo | undefined) => {
        set({ headerInfo: info });
      },
      setFilter: (value: filter<articleManagementFilter>[]) => {
        set({ page: 1, filter: value });
      },
      setSelectedArticlesId: (value: Key[]) => {
        set({ selectedArticlesId: value });
      },
      page: 1,
      setPage: (value: number) => {
        set({ page: value });
      },
    };
  }
);
